import { Comment } from 'app/model/comment';
import { StoreMetric } from 'app/model/metrics/store-metric';
import { ToplineMetric } from 'app/model/metrics/topline-metric';
import { SeamPattern } from 'app/model/seam-pattern';
import { SeamRequest } from 'app/model/seam-request';
import { RootState } from 'app/store';
import { ModelWithoutId } from 'app/type/model-with-id';

export const selectSelectedRequest = (state: RootState): SeamRequest | undefined => state.seam.selectedRequest;
export const selectSelectedPattern = (state: RootState): ModelWithoutId<SeamPattern> | undefined =>
    state.seam.selectedPattern;
export const selectSeamComments = (state: RootState): Comment[] => state.seam.seamComments;
export const selectRequestPatterns = (state: RootState): SeamPattern[] | undefined => state.seam.seamPatterns;
export const selectToplineMetric = (state: RootState): ToplineMetric[] | undefined => state.seam.overallMetrics;
export const selectStoreMetric = (state: RootState): StoreMetric[] | undefined => state.seam.storeMetrics;
export const selectStoreGraphMetric = (state: RootState): StoreMetric[] | undefined => state.seam.storeGraphMetrics;
